import React from 'react';
import { MODULE_DISPLAY_NAMES } from '../../../../services/noteTypeService';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import styles from './NoteTypes.module.css';

const NoteTypeList = ({ 
    noteTypes, 
    loading, 
    onEdit, 
    onDelete, 
    filterModule,
    setFilterModule,
    searchQuery,
    setSearchQuery
}) => {
    // Get visible modules for a note type
    const getActiveModules = (noteType) => {
        const modules = [];
        if (noteType.visibleClientServices) modules.push(MODULE_DISPLAY_NAMES.ClientServices);
        if (noteType.visibleBilling) modules.push(MODULE_DISPLAY_NAMES.Billing);
        if (noteType.visibleSampleControl) modules.push(MODULE_DISPLAY_NAMES.SampleControl);
        if (noteType.visibleLaboratory) modules.push(MODULE_DISPLAY_NAMES.Laboratory);
        if (noteType.visibleQA) modules.push(MODULE_DISPLAY_NAMES.QA);
        if (noteType.visibleClient) modules.push(MODULE_DISPLAY_NAMES.Client);
        return modules;
    };

    if (loading) {
        return (
            <div className={styles.loading}>
                <div className={styles.spinner}></div>
                <p>Loading note types...</p>
            </div>
        );
    }

    // Store whether we have any filters active
    const hasFilters = searchQuery || filterModule;

    if (noteTypes.length === 0 && !hasFilters) {
        return (
            <div className={styles.emptyState}>
                <h3>No Note Types Found</h3>
                <p>Create your first note type to get started.</p>
            </div>
        );
    }

    return (
        <div className={styles.listContainer}>
            <div className={styles.tableHeader}>
                <div className={styles.tableHeaderContent}>
                    <h3>Note Types ({noteTypes.length})</h3>
                    <div className={styles.tableFilters}>
                        <div className={styles.filterGroup}>
                            <label htmlFor="searchFilter">Search:</label>
                            <input
                                id="searchFilter"
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search by name or description..."
                                className={styles.searchInput}
                            />
                        </div>
                        <div className={styles.filterGroup}>
                            <label htmlFor="moduleFilter">Filter by Module:</label>
                            <select
                                id="moduleFilter"
                                value={filterModule}
                                onChange={(e) => setFilterModule(e.target.value)}
                                className={styles.select}
                            >
                                <option value="">All Modules</option>
                                {Object.entries(MODULE_DISPLAY_NAMES).map(([key, label]) => (
                                    <option key={key} value={key}>
                                        {label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className={styles.table}>
                <div className={styles.tableHead}>
                    <div className={styles.row}>
                        <div className={styles.cell}>Name</div>
                        <div className={styles.cell}>Description</div>
                        <div className={styles.cell}>Note Visibility</div>
                        <div className={styles.cell}>Actions</div>
                    </div>
                </div>
                
                <div className={styles.tableBody}>
                    {noteTypes.length === 0 && (
                        <div className={styles.noResults}>
                            <p>No note types match your search criteria</p>
                            {searchQuery && <p>Search: "{searchQuery}"</p>}
                            {filterModule && <p>Module: {MODULE_DISPLAY_NAMES[filterModule]}</p>}
                        </div>
                    )}
                    {noteTypes.map((noteType) => (
                        <div key={noteType.noteTypeId} className={styles.noteTypeRow}>
                            <div className={styles.row}>
                                <div className={styles.cell}>
                                    <div className={styles.nameCell}>
                                        <span className={styles.name}>{noteType.noteTypeName}</span>
                                        <span className={styles.id}>ID: {noteType.noteTypeId}</span>
                                    </div>
                                </div>
                                
                                <div className={styles.cell}>
                                    <div className={styles.description}>
                                        {noteType.noteTypeDesc || <span className={styles.noDescription}>No description</span>}
                                    </div>
                                </div>
                                
                                <div className={styles.cell}>
                                    <div className={styles.moduleList}>
                                        {getActiveModules(noteType).map((module) => (
                                            <span key={module} className={styles.moduleTag}>
                                                {module}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                                
                                <div className={styles.cell}>
                                    <div className={styles.actions}>
                                        <button
                                            onClick={() => onEdit(noteType)}
                                            className={styles.editButton}
                                            title="Edit"
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            onClick={() => onDelete(noteType)}
                                            className={styles.deleteButton}
                                            title="Delete"
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NoteTypeList;
